// store/modules/user.js



export default {
    namespaced: true, // 命名空间模块化
    state: () => ({
        isSearchPPTList: false,
        isUpload: false,
        uploadModel: false,
        fileId: '',
        tabrList: []
    }),
    mutations: {
        SEARCHPPT: (state, isSearchPPTList) => {
            state.isSearchPPTList = isSearchPPTList;
        },
        ISUPLOAD: (state, isUpload) => {
            state.isUpload = isUpload;
        },
        UPLOADMODEL: (state, uploadModel) => {
            state.uploadModel = uploadModel;
        },
        SETFILE_ID: (state, fileId) => {
            state.fileId = fileId;
        },
        SRTTABRLIST: (state, list) => {
            state.tabrList = list;
        },
    },
    actions: {
        searchPPT({ commit }, isSearchPPTList) {
            console.log('触发store' + isSearchPPTList)
            commit("SEARCHPPT", isSearchPPTList);
        },
        isUpload({ commit }, isUpload) {
            console.log('isUpload' + isUpload)
            commit("ISUPLOAD", isUpload);
        },
        upLoadModel({ commit }, uploadModel) {
            console.log('uploadModel' + uploadModel)
            commit("UPLOADMODEL", uploadModel);
        },
        setFileID({ commit }, fileId) {
            commit("SETFILE_ID", fileId);
        },
        setTabrList({ commit }, list) {
            commit("SRTTABRLIST", list);
        },
    }
};
